
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class MailTo extends Vue {
    @Prop({ type: String, required: true }) readonly email!: string;

    get mailTo(): string {
      return `mailto:${this.email}`;
    }
  }
